import React from 'react';
import styles from './FeedBannerSlider.module.scss';

/**
 * Creative skeleton for the hero banner. Mirrors the real layout (title, lines, CTA, media)
 * with same .hero/.container/.slider dimensions so no layout shift on load (all devices).
 */
const HeroBannerSkeleton: React.FC = () => (
  <section className={styles.hero} aria-label="Banner loading">
    <div className={styles.container}>
      <div className={`${styles.slider} ${styles.skeletonSlider}`}>
        <div className={styles.skeletonBg} aria-hidden />
        <div className={styles.skeletonSlide}>
          <div className={styles.skeletonContent}>
            <div className={`${styles.skeletonBlock} ${styles.skeletonTitle}`} />
            <div className={`${styles.skeletonBlock} ${styles.skeletonLine1}`} />
            <div className={`${styles.skeletonBlock} ${styles.skeletonLine2}`} />
            <div className={`${styles.skeletonBlock} ${styles.skeletonLine3}`} />
            <div className={`${styles.skeletonBlock} ${styles.skeletonCta}`} />
          </div>
          <div className={styles.skeletonMedia}>
            <div className={styles.skeletonMediaInner}>
              <div className={styles.skeletonMediaIcon}>
                <i className="fas fa-image" aria-hidden />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.skeletonFooter}>
          <span className={styles.skeletonDot} />
          <span className={styles.skeletonDot} />
          <span className={styles.skeletonDot} />
        </div>
        <div className={styles.skeletonShimmer} aria-hidden />
      </div>
    </div>
  </section>
);

export default HeroBannerSkeleton;
